// extracted by mini-css-extract-plugin
export default {"root":"today-module___root___a310f720"};